<template>
  <div>
    <van-overlay :show="show" >
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="top"> 
            <div class="top-title">Automatic loan</div>
            <div class="tips">
              When you liquidate the order we will automatically apply for the next loan for you to this product, and you can receive the loan more quickly
            </div>

            <div class="loan-title">Estimated amount for automatic loan</div>

            <div class="loannum">
              ₹{{ settledAutoApplyAmount?dataMoney(settledAutoApplyAmount):"0" }}
            </div>

            <div class="account-centent">
              <div class="account-title">
                Receiving account:
              </div>
              <div class="bankItem">
                <div class="itemLeft">Bank name</div>
                <div class="itemRight">{{ data? data.bankName:'' }}</div>
              </div>
              <div class="bankItem">
                <div class="itemLeft">IFSC</div>
                <div class="itemRight">{{ data? data.bankCode:'' }}</div>
              </div>
              <div class="bankItem">
                <div class="itemLeft">Bank Account No</div>
                <div class="itemRight">{{ data? data.bankCard:'' }}</div>
              </div>
            </div>

            <div class="bottom-tip">
              The pass rate of automatic loan application is up to 
              <span>95%</span>
            </div>

            <van-button
              type="primary"
              class="bottom-btn"
              v-if="showBtn"
              @click="RepaymentOnly">
              Repay Now
            </van-button>

            <div class="checkedAuto" @click="clickChecked">
              <van-checkbox v-model="checked">
                  <template #icon="props">
                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                  </template>
              </van-checkbox>
              <div class="checkText" v-if="checked">
                Automatic loan enabled
              </div>
              <div class="checkText" v-if="!checked">
                Auto reapply loan without waiting
              </div>
            </div>
          </div>
          <img src="@/assets/offbtn.png" alt="" @click="entiendo" class="close-icon" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { dataMoney } from '@/utils/money'
import { getBankCard,getSettledAutoApply} from "@/views/normalExtension/lib.js"
export default {
  data () {
    return {
      show: false,
      showBtn:false,
      checked:true,
      data:null,
      url:null,
      loadingBtn:null,
      orderNo:null,
      settledAutoApplyAmount:null,
      activeIcon: require('@/assets/on.png'),
      inactiveIcon: require('@/assets/reoff.png'),
    }
  },
  methods: {
    dataMoney,
    entiendo () {
      this.show = false
      this.checked=true
      
    },
    //     handleOverlayClick(event){
    // // console.log(event,'event');
    // if (event.target._prevClass === 'wrapper') {
    //     this.show = false; // 点击 van-overlay 盒子时触发关闭操作
    //   }
    // //  }
    // },
    async getBankCard(){
      this.$managementEvents({ pageName: 'voice', action: 'chase', extInfo: {  isApply: true, } })
      this.data=null
      const loadingInstance = Toast.loading(
        {
          message: 'Loading...',
          duration: 0, // 设置为 0 表示持续加载直到手动关闭
          forbidClick: true, // 防止用户点击
          closeOnClick: false // 设置为 true 可以点击关闭 loading
        }
      )
   const res=await getBankCard()
   console.log(res,'银行卡信息');
   if(res.authority==='200'){
    this.data=JSON.parse(res.same[0].same)
    if( this.data){
    loadingInstance.clear()
   }
    console.log(this.data,'data');
   }else{
    loadingInstance.clear()
   }
   
  },
    async automaticLoan(){
      const loadingInstance = Toast.loading(
        {
          message: 'Loading...',
          duration: 0, // 设置为 0 表示持续加载直到手动关闭
          forbidClick: true, // 防止用户点击
          closeOnClick: false // 设置为 true 可以点击关闭 loading
        }
      )
  if (this.loadingBtn) return
      this.loadingBtn = true

    const res=await getSettledAutoApply({
      type:this.checked,
      // orderNo:'2024020415501093585951' //170状态 放款成功
      orderNo:this.orderNo, //180状态 放款成功
     })
     if(res.authority==='200'){
      loadingInstance.clear()
      this.$router.push({ name: 'easyPay', params: { url:this.url,name:'normalExtension' } })
      // window.location.href=this.url
     }else{
      loadingInstance.clear()
     }
     setTimeout(() => {
        // 模拟操作完成后的处理
        console.log('操作完成')
       loadingInstance.clear()
        this.loadingBtn = false // 操作完成后将加载状态设置为false，允许下次点击
      }, 1000) // 这里的1000表示操作的耗时，实际情况根据具体操作来确定

      
  },
  clickChecked(){
    this.checked=!this.checked
    this.$managementEvents({ pageName: 'voice', action: 'chase', extInfo: {  isApply: this.checked, } })
  },
 async RepaymentOnly(){
  const loadingInstance = Toast.loading(
        {
          message: 'Loading...',
          duration: 0, // 设置为 0 表示持续加载直到手动关闭
          forbidClick: true, // 防止用户点击
          closeOnClick: false // 设置为 true 可以点击关闭 loading
        }
      )
    if (this.loadingBtn) return
    const res = await getSettledAutoApply({
        type: this.checked,
        // orderNo:'2024020415501093585951' //170状态 放款成功
        orderNo: this.orderNo // 180状态 放款成功
      })
      if (res.code === '200') {
        loadingInstance.clear()
      }
      this.loadingBtn = true
      loadingInstance.clear()
      this.$router.push({ name: 'easyPay', params: { url:this.url,name:'normalExtension' } })
    setTimeout(() => {
        // 模拟操作完成后的处理
        console.log('操作完成')

        this.loadingBtn = false // 操作完成后将加载状态设置为false，允许下次点击
      }, 1000) // 这里的1000表示操作的耗时，实际情况根据具体操作来确定
  }

 

  },
  mounted(){
    // this.getBankCard()
  }

}
</script>

<style lang="less" scoped>
.van-overlay {
  z-index: 999;
}
.img-icon{
  height: 20px;
  width: 20px;
}
.wrapper {

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
 
  .block {
    width: 343px;
    height: auto;
    max-height: 90%;
    position: relative;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    padding: 24px 20px 20px 20px;
    border-radius: 16px;
    .close-icon {
    width: 30px;
    height: 30px;
    border: none;
    left: 50%;
    bottom:-20px;
    transform: translate(-50%, 100%);
    position: absolute;
  }

    .top {
      .top-title {
        color: #000000;
        font-size: 20px;
        font-weight: bold;
      }
      .tips{
        font-family: 'Roboto, Roboto';
        font-size: 14px;
        line-height: 16px;
        color: #000000;
        margin: 16px 13px 20px 14px;
      }
      .loan-title{
        color: #4A44C6;
        font-size: 14px;
        line-height: 16px;
        font-weight: bold;
      }
      .loannum{
        margin-top: 16px;
        font-size: 32px;
        color: #000000;
        font-weight: bold;
      }
      .account-centent{
        .account-title{
          text-align: left;
          color: #000000;
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .bankItem {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 16px;
          .itemLeft {
            color: #B4B4B4;
            font-size: 14px;
            width: 120px;
            text-align: left;
            flex-shrink: 0;
            margin-right: 10px;
          }
          .itemRight {
            flex: 1;
            color: #000000;
            font-size: 14px;
            word-break: break-all;
            text-align: right;
          }
        }
      }
      .bottom-tip{
        font-size: 14px;
        color: #B4B4B4;
        margin: 18px 13px 12px 14px;
        span {
          color: #000000;
          font-weight: 500;
        }
      }
      .bottom-btn{
        width: calc(100% - 8px);
        background-color: #4A44C6;
        border-radius: 24px;
        color: #FFFFFF;
        font-size: 16px;
        font-weight: bold;
        border: none;
      }
      .checkedAuto {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 14px;
        .checkText {
          color: #B4B4B4;
          font-size: 13px;
          margin-left: 4px;
        }
      }
    }
  }
}</style>
